module.exports = __webpack_public_path__ + "img/Demolition.d1ba689c.svg";